// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__NOt-U","modalFooterButton":"ModalNotes_modalFooterButton__5cui8"};